<template>
  <div>
    <a-form-model ref="form" :model="form.data" :rules="form.rules">
      <a-form-model-item :label="$t('问题')" prop="title">
        <div class="a-input">
          <a-input v-model="form.data.title"/>
        </div>
      </a-form-model-item>
      <a-form-model-item :label="$t('问题英文')" prop="titleEn">
        <div class="a-input">
          <a-input v-model="form.data.titleEn"/>
        </div>
      </a-form-model-item>
      <a-form-model-item :label="$t('答案')" prop="content">
        <div class="a-input">
          <a-textarea v-model="form.data.content"/>
        </div>
      </a-form-model-item>
      <a-form-model-item :label="$t('答案英文')" prop="contentEn">
        <div class="a-input">
          <a-textarea v-model="form.data.contentEn"/>
        </div>
      </a-form-model-item>
<!--      <a-form-model-item :label="$t('ANSWER')" prop="coverPath">-->
<!--        <div-->
<!--          class="answer-wrap"-->
<!--             :key="`answer_${index}`"-->
<!--             v-for="(item,index) in form.data.answers">-->
<!--          <a-input v-model="item.content">-->
<!--            <a-checkbox slot="addonBefore" v-model="item.isRight"/>-->
<!--            <a-icon type="minus" @click="removeAnswer(item)" style="color: red" slot="addonAfter"/>-->
<!--          </a-input>-->
<!--        </div>-->
<!--        <a-button block type="danger" @click="addAnswer">{{ $t('ADD') }}</a-button>-->
<!--      </a-form-model-item>-->
      <a-form-model-item>
        <a-space>
          <a-button
            type="primary"
            v-if="!questionId"
            @click="onAdd">{{ $t('CREATE') || '创建' }}
          </a-button>
          <a-button
            type="primary"
            v-if="questionId"
            @click="onUpdate">{{ $t('UPDATE') || '更新' }}
          </a-button>
          <a-button
            @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import {
  _queryQuestion,
  _addQuestion,
  _updateQuestion,
} from '@/api/questionApi';

async function getQuestion() {
  const result = await _queryQuestion(this.questionId);
  if (result) {
    this.form.data.title = result.title;
    this.form.data.titleEn = result.titleEn;
    this.form.data.content = result.content;
    this.form.data.contentEn = result.contentEn;
    // this.form.data.answers = result.answers.map(x => ({
    //   ...x,
    //   isRight: x.isRight === 'YES',
    // }));
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addQuestion({
        title: this.form.data.title,
        titleEn: this.form.data.titleEn,
        content: this.form.data.content,
        contentEn: this.form.data.contentEn,
        // isActive: 'YES',
        // answers: this.form.data.answers.map(x => ({
        //   ...x,
        //   isRight: x.isRight ? 'YES' : 'NO',
        // })),
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('ADD_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateQuestion(this.questionId, {
        title: this.form.data.title,
        titleEn: this.form.data.titleEn,
        content: this.form.data.content,
        contentEn: this.form.data.contentEn,
        // isActive: 'YES',
        // answers: this.form.data.answers.map(x => ({
        //   ...x,
        //   isRight: x.isRight ? 'YES' : 'NO',
        // })),
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('UPDATE_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

function reviewVideo() {
  if (this.form.data.videoPath) {
    this.video.visible = true;
  }
}

function addAnswer() {
  this.form.data.answers = [...this.form.data.answers, {
    content: '',
    isRight: false,
  }];
}

function removeAnswer(item) {
  this.form.data.answers = this.form.data.answers.filter(x => x.content !== item.content);
}

export default {
  name: 'QuestionEdit',
  components: {},
  props: {
    questionId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    questionId() {
      if (this.questionId) {
        this.getQuestion();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getQuestion,
    reviewVideo,
    addAnswer,
    removeAnswer,
  },
  data() {
    return {
      video: {
        visible: false,
        url: '',
      },
      form: {
        data: {
          title: '',
          titleEn: '',
          content: '',
          contentEn: '',
          // answers: [
          //   {
          //     content: '',
          //     isRight: true,
          //   },
          // ],
        },
        rules: {
          title: [{
            required: true,
            trigger: 'blur',
          }],
          titleEn: [{
            required: true,
            trigger: 'blur',
          }],
          content: [{
            required: true,
            trigger: 'blur',
          }],
          contentEn: [{
            required: true,
            trigger: 'blur',
          }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.questionId) {
      this.getQuestion();
    }
  },
};
</script>
